import { render, staticRenderFns } from "./tms.vue?vue&type=template&id=0c8288ee&scoped=true"
import script from "./tms.vue?vue&type=script&lang=js"
export * from "./tms.vue?vue&type=script&lang=js"
import style0 from "./tms.vue?vue&type=style&index=0&id=0c8288ee&lang=css"
import style1 from "./tms.vue?vue&type=style&index=1&id=0c8288ee&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8288ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c8288ee')) {
      api.createRecord('0c8288ee', component.options)
    } else {
      api.reload('0c8288ee', component.options)
    }
    module.hot.accept("./tms.vue?vue&type=template&id=0c8288ee&scoped=true", function () {
      api.rerender('0c8288ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/tms.vue"
export default component.exports